import { DenialLetterUploadStatus } from "../../../../enums/denialLetterUploadStatus";

export const shouldOpenLetterUploadModal = (
  letterUploadStatus: string,
): boolean => {
  if (letterUploadStatus === DenialLetterUploadStatus.NOT_INITIATED) {
    return false;
  }
  if (letterUploadStatus === DenialLetterUploadStatus.IN_PROGRESS) {
    return false;
  }
  if (letterUploadStatus === DenialLetterUploadStatus.LETTER_NOT_FOUND) {
    return false;
  }
  if (letterUploadStatus === DenialLetterUploadStatus.NOT_APPLICABLE) {
    return false;
  }
  if (letterUploadStatus === DenialLetterUploadStatus.COMPLETED) {
    return true;
  }
  if (letterUploadStatus === DenialLetterUploadStatus.SUCCESS) {
    return true;
  }
  if (letterUploadStatus === DenialLetterUploadStatus.FAILED) {
    return true;
  }
  if (letterUploadStatus === DenialLetterUploadStatus.ERROR) {
    return true;
  }
  return false;
};
